const BOOKING_URL = "https://calendar.google.com/appointments/schedules/AcZssZ08X5lSuK34vRxmIpC-2u_5llw64sbNwzv7_Hwe21weB-35bNE_4P-xKQT5UmbASGOcktq_Awlw";

export const trackBookingConversion = () => {
  if (typeof window !== "undefined" && (window as any).gtag_report_conversion) {
    (window as any).gtag_report_conversion(BOOKING_URL);
  }
};

export { BOOKING_URL };
